import React from 'react'
import { Modal } from '@enamelai/design-system'
import { Icon as AlertIcon } from '@enamelai/design-system/icons/Alert'

type UnsavedChangesModalProps = {
  show: boolean
  onConfirm: () => void
  onHide: () => void
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  show,
  onConfirm,
  onHide,
}) => {
  return (
    <Modal
      open={show}
      onClose={onHide}
      size="sm"
      variant="confirmation"
      icon={<AlertIcon width={16} height={16} aria-hidden="true" />}
      iconTone="warning"
      title="Discard unsaved changes?"
      className="unsaved-changes-modal"
      description="You have unsaved changes. Leaving this page will discard them. Are you sure you want to leave?"
      primaryLabel="Cancel anyway"
      primaryDestructive
      secondaryLabel="Back"
      onPrimaryClick={onConfirm}
      onSecondaryClick={onHide}
    />
  )
}
export default UnsavedChangesModal
